import {DashboardSettingListMapType, DashboardSettingSearchParamType} from "../../detail/interface";
import {Dispatch, SetStateAction} from "react";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {PaginationMain} from "../../../../../components/common/pagination/PaginationMain";
import {useUpdateDashboardHiddenSetting} from "../hooks/useUpdateDashboardHiddenSetting";
import {useModal} from "../../../../../hooks";

interface PropsType {
    dashboardSetting: DashboardSettingListMapType
    searchParam: DashboardSettingSearchParamType
    selectedItem: number[]
    setSelectedItem: Dispatch<SetStateAction<number[]>>
}

export default function List({dashboardSetting, searchParam, selectedItem, setSelectedItem}: PropsType) {
    const {handleModal} = useModal();

    const dataList = dashboardSetting.dashboardInfoVOList ?? []
    const totalCount = dashboardSetting.totalCount ?? 0

    const closeCallback = () => setSelectedItem([])
    const {mutate: mutateUpdateDashboardHiddenSetting} = useUpdateDashboardHiddenSetting({closeCallback: closeCallback})

    const isAllCheck = dataList.length !== 0 && dataList.every(el => selectedItem.map(el2 => el2).includes(el.dashboardInfoId))

    const clickAllCheck = () => {
        if (isAllCheck) {
            const list = selectedItem.filter(el => !dataList.map(el => el.dashboardInfoId).includes(el))

            setSelectedItem(list)
        } else {
            // @ts-ignore
            const list = [...new Set([...selectedItem, ...dataList.map(el => el.dashboardInfoId)])]

            setSelectedItem(list)
        }
    }

    const clickCheck = (idx: number) => {
        if (selectedItem.includes(idx)) {
            const list = selectedItem.filter(el2 => idx !== el2)

            setSelectedItem(list)
        } else {
            setSelectedItem([...selectedItem, idx])
        }
    }

    const btnChangeHidden = (str: "Y" | "N") => {
        if (selectedItem.length === 0) {
            handleModal({
                isOpen: true,
                contents: "수정할 항목이 없습니다.",
                type: "alert"
            })
        } else {
            const list = dataList
                .filter(el => selectedItem.includes(el.dashboardInfoId))
                .map(el => ({...el, isHidden: str}))

            mutateUpdateDashboardHiddenSetting(list)
        }
    }

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">대시보드 구성 목록(<span>{totalCount}</span>건)</h6>
            <div className="table_toolbar">
                <button className="btn btn-outline-secondary w-96px px-0" onClick={() => btnChangeHidden("Y")}>노출 비활성
                </button>
                <button className="btn btn-secondary w-80px px-0" onClick={() => btnChangeHidden("N")}>노출 활성</button>
            </div>
        </div>

        <div className="table_scroll">
            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    <th style={{width: "4.37%"}}>
                        <div className="checkbox_outer">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isAllCheck}
                                onClick={clickAllCheck}
                            />
                        </div>
                    </th>
                    <th style={{width: "7.5%"}}>No</th>
                    <th style={{width: "61.25%"}}>레포트명</th>
                    <th style={{width: "13.75%"}}>형식</th>
                    <th>상태</th>
                </tr>
                </thead>
                <tbody>
                {dataList.length !== 0
                    ? dataList.map((el, idx) =>
                        <tr className={selectedItem.includes(el.dashboardInfoId) ? "lightblue clickable" : "clickable"}
                            onClick={() => clickCheck(el.dashboardInfoId)}>
                            <td className="text-center">
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={selectedItem.includes(el.dashboardInfoId)}
                                    />
                                </div>
                            </td>
                            <td className="text-center">{((searchParam.pageNo - 1) * 10) + idx + 1}</td>
                            <td>{el.reportName}</td>
                            <td className="text-center">{el.dashboardType}</td>
                            {el.isHidden === "N" && <td className="text-center text-primary">활성</td>}
                            {el.isHidden === "Y" && <td className="text-center text-light">비활성</td>}
                        </tr>)
                    : <EmptyTableRow colSpan={5}/>
                }
                </tbody>
            </table>
        </div>

        <PaginationMain totalCount={totalCount}/>
    </div>
}